import { render, staticRenderFns } from "./SnakeInNav.vue?vue&type=template&id=1f6d30df&scoped=true&"
import script from "./SnakeInNav.vue?vue&type=script&lang=js&"
export * from "./SnakeInNav.vue?vue&type=script&lang=js&"
import style0 from "./SnakeInNav.vue?vue&type=style&index=0&id=1f6d30df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6d30df",
  null
  
)

export default component.exports